// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TripleCheckGender } from './tripleCheckGender.js';
import type { TripleCheckPatientAddress } from './tripleCheckPatientAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TripleCheckPatientRequest {
    'address': TripleCheckPatientAddress | null;
    'dateOfBirth': Moment;
    'firstName': string;
    'gender': TripleCheckGender;
    'lastName': string;
    'phone'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TripleCheckPatientRequest>> = [
        {
            "name":     "address",
            "baseName": "address",
            "type":     "TripleCheckPatientAddress"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "Date"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "TripleCheckGender"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "phone",
            "baseName": "phone",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TripleCheckPatientRequest.attributeTypeMap;
    }
}
